<template>
  <main-buttons-bar :align="'space-between'">
    <template #left>
      <custom-title>Listado de grupos de elmentos</custom-title>
    </template>
    <template #right>
      <el-button
        type="primary"
        size="default"
        :icon="IconAdd"
        style="margin-right: 1rem"
        @click="nuevoGrupo"
        >Nuevo grupo</el-button
      >
      <setting-modal-abm
        v-if="modalNuevoProductoVisible"
        :visible="modalNuevoProductoVisible"
        @cerrar-modal="cerrarModalNuevoGrupo"
      />
    </template>
  </main-buttons-bar>
  <el-table
    ref="custom_table"
    :data="elementosGrupo"
    :style="{ width: '100%' }"
    :highlight-current-row="false"
    empty-text="Sin datos"
    border
  >
    <el-table-column
      prop="Codigo"
      label="Código"
      width="120"
      sortable
    ></el-table-column>
    <el-table-column
      prop="Descripcion"
      label="Descripción"
      width="200"
      sortable
    ></el-table-column>
    <el-table-column
      label="Acciones"
      width="200"
      align="center"
    >
      <template #default="scope">
        <el-button
          :icon="IconEdit"
          @click.prevent="modificarElementoTipo(scope.row)"
        />
        <el-button
          :icon="IconDelete"
          @click.prevent="deshabilitarElementoTipo(scope.row)"
        />
      </template>
    </el-table-column>
  </el-table>
</template>

<script setup>
import {
  ref,
  onBeforeMount,
} from 'vue';
import { storeToRefs } from 'pinia';
import IconAdd from '~icons/mdi/add';
import IconDelete from '~icons/mdi/delete';
import IconEdit from '~icons/mdi/edit';
import CustomTitle from '@/shared/components/custom_title.vue';
import MainButtonsBar from '@/shared/layout/main/buttons_bar/main_buttons_bar.vue';
import SettingModalAbm from './element_group/setting_modal_abm.vue';
import { useElementoGrupoStore } from '@/stores/elemento_grupo/elemento_grupo_store.js';
import { useElementoTipoStore } from '@/stores/elemento_tipo/elemento_tipo_store.js';
import elemento_grupo_model from '@/shared/models/elemento_grupo_model.js';
import { useLoading } from '@/shared/composables/loading.js';
import { useMessageError } from '@/shared/composables/message_error.js';
import { useMessageSuccess } from '@/shared/composables/message_success.js';

const modalNuevoProductoVisible = ref(false);

const elementoGrupoStore = useElementoGrupoStore();
const { firstElementoGrupo } = elementoGrupoStore;
const { elementosGrupo, elementoGrupo } = storeToRefs(elementoGrupoStore);

const elementoTipoStore = useElementoTipoStore();

const abrirModalNuevoProducto = () => {
  modalNuevoProductoVisible.value = true;
};

const cerrarModalNuevoGrupo = () => {
  modalNuevoProductoVisible.value = false;
};

const modificarElementoTipo = async (elemento) => {
  if (elemento) {
    await elementoGrupoStore.findElementoGrupoPorCodigoHTTP(elemento.Codigo);
    abrirModalNuevoProducto();
  }
};
const nuevoGrupo = async () => {
  elementoGrupo.value = JSON.parse(JSON.stringify(elemento_grupo_model));
  abrirModalNuevoProducto();
};

const deshabilitarElementoTipo = async (elemento) => {
  if (elemento) {
    try {
      useLoading().openLoading();
      await elementoGrupoStore.deleteElementoGrupoPorCodigoHTTP(elemento.Codigo);
      await elementoGrupoStore.findAllElementosGrupoHTTP({ page: 0 });
      useMessageSuccess().open(`El grupo de tipos de elementos seleccionado fue eliminado!`);
    } catch (err) {
      useMessageError().open(`Ha ocurrido un error al intentar eliminar el grupo: ${err}`);
    } finally {
      useLoading().closeLoading();
    }
  }
};
onBeforeMount(async () => {
  await firstElementoGrupo(0);
  await elementoTipoStore.resetElementoTipoList();
});
</script>
